function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 512 512",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m512 256-48.596 47.361 23.287 63.747-64.385 21.495-6.679 67.547-67.338-8.466-35.328 57.951L256 468.69l-56.96 36.945-35.33-57.951-67.338 8.465-6.678-67.546-64.385-21.495 23.288-63.747L0 256l48.597-47.361-23.288-63.747 64.386-21.495 6.678-67.546 67.338 8.465L199.04 6.365 256 43.31l56.961-36.945 35.329 57.951 67.338-8.465 6.678 67.547 64.386 21.495-23.288 63.746z",
    style: {
      fill: "#e8ba44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 256-48.596-47.361 23.288-63.746-64.386-21.495-6.678-67.547-67.338 8.465-35.329-57.951L256 43.31v425.38l56.961 36.945 35.328-57.951 67.338 8.466 6.679-67.547 64.385-21.495-23.287-63.747z",
    style: {
      fill: "#e49524"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.996,
    cy: 255.996,
    r: 147.773,
    style: {
      fill: "#f1d849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.778 256c0 81.614-66.162 147.777-147.777 147.777V108.223c81.615 0 147.777 66.163 147.777 147.777z",
    style: {
      fill: "#e8ba44"
    }
  }));
};
export default SvgSun;